import { AutoComplete as BaseAutoComplete } from "antd";
import styled, { css } from "styled-components";

import handleSpaces, { spacingProps } from "../utils/handleSpaces";
import color from "../_style/color";

const AutoComplete = styled(BaseAutoComplete).attrs((props) => ({
  width: props.width || "",
  bordered: props.bordered || false,
  ...spacingProps(props),
}))`
  width: ${({ width }) => width};
  border: none;

  ${({ bordered }) => bordered && css`border: border: 1px solid ${color.dimGray};`}

  ${(props) =>
    css`
      ${handleSpaces(props)}
    `}
`;

export default AutoComplete;
